module.exports = __webpack_public_path__ + "img/system-county-oz.46bf579b.png";